/** `?fenetre=` values of the onboarding list and sheet (kept apart so the routes do not load the windows). */
export const FENETRES = ["profil", "rappel", "rappel-aide", "configurer", "honoraires", "suite", "lettre", "rappels", "paiement", "activer", "visio", "reattribuer", "annuler", "ecrire"] as const;
export type Fenetre = (typeof FENETRES)[number];
